module.exports = [{"type":"hash","text":"接入方式"},{"type":"normal","text":"行情Websocket的接入URL：wss://open-api-cswap-ws.bingx.com/market"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/introduce/01_connect.json
// module id = 3tXb
// module chunks = 3